import React, { useState } from 'react'
import { Image } from '../atoms/image'

export const ConfirmModal = () => {

  const [open, setOpen] = useState<boolean>(true)
  return (
    <div className={`confirmModalWrapper ${open && "confirmModalWrapper--open"}`}>
      <div className="confirmModalWrapper__overlay" />
      <div className="confirmModal">
        <div className="confirmModal--centerArea">
          <Image imageName="logo-large.png" className="confirmModal__logo" />
        </div>
        <div className="confirmModal--centerArea">
          <Image imageName="arainer.png" className="confirmModal__aligner" />
        </div>
        <p className="confirmModal__description">
          医療関係者を対象に適正に<br />使用していただくための情報を提供しています。<br />
          一般の方に対する情報提供を目的としたものではごさいませんのでご了承ください。<br />
        </p>
        <p className="confirmModal__confirm">あなたは医療関係者ですか？</p>
        <div className="confirmModal--buttonArea">
          <button onClick={() => setOpen(false)}>はい</button>
          <button onClick={() => window.location.href = "https://hanalove.jp/"}>いいえ</button>
        </div>
      </div>
    </div>
  )
}
